<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component
        :messages="messagesError"
        :error="isError"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="isError = $event"/>
      <header class="has-text-centered">
        <p class="is-size-5 has-text-weight-bold">
          {{ $t('detailContrat.indexation.popUpIndexation.title') }}
        </p>
      </header>
      <section class="mgt-10px">
        <resume-indexation :item-indexe="contrat" />
        <div class="tab">
          <ul>
            <li :class="{'is-active': activeTab === 'indexation'}"
                @click="activeTab = 'indexation'">
              {{ $t('detailContrat.indexation.popUpIndexation.tabIndexation') }}
            </li>
            <li :class="{'is-active': activeTab === 'echeancier'}"
                @click="activeTab = 'echeancier'">
              {{ $t('detailContrat.indexation.popUpIndexation.tabEcheancier',
                { nb: echeanciers.length }) }}
            </li>
          </ul>
        </div>
        <div>
          <form-indexation
            v-if="activeTab === 'indexation'"
            :contrat="contrat"
            :payload="payload"
            :indiceEtValeurs="indiceEtValeurs"
          />
          <echeancier-indexe
            v-if="activeTab === 'echeancier'"
            :contrat="contrat"
            :payload="payload"
          />
        </div>
      </section>
      <footer class="mgt-10px">
        <div class="buttons">
          <button
            class="button has-text-centered"
            @click="$emit('close')">
            {{ $t('general.button.cancel') }}
          </button>
          <button
            class="button is-primary has-text-centered"
            @click="indexeContrat">
            {{ $t('general.button.valider') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import { getAll } from '@/api/indiceEtValeur/';
import { indexation } from '@/api/baux/contrat';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import formatDateIso from '@/services/general/formatIsoDate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import formIndexation from '@/components/baux/contrat/componentDetail/popUpIndexationBail/FormIndexation';
import resumeIndexation from '@/components/baux/contrat/componentDetail/popUpIndexationBail/ResumeIndexation';
import echeancierIndexe from '@/components/baux/contrat/componentDetail/popUpIndexationBail/EcheancierIndexe';
import validationGeneral from '@/services/validation/validation';
import validation from '@/services/baux/contrat/validation';
import translate from '@/services/baux/contrat/translatorIndexationContrat';
import {
  LISTE_TYPE_INDEXATION,
  TYPE_INDEXATION_INDICE,
  TYPE_INDEXATION_POURCENTAGE,
} from '@/configuration/baux/contrat/contratConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

export default {
  props: {
    contrat: {
      type: Object,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
    formIndexation,
    resumeIndexation,
    echeancierIndexe,
  },
  data() {
    return {
      activeTab: 'indexation',
      indiceEtValeurs: [],
      messagesChampsVide: [],
      champsVide: [],
      isError: false,
      messagesError: [],
      payload: {
        indiceSelected: null,
        dateIndexation: new Date(),
        dateIndexationActuel: new Date(),
        valeurIndexationActuel: null,
      },
      constantes: {
        LISTE_TYPE_INDEXATION,
        TYPE_INDEXATION_INDICE,
        TYPE_INDEXATION_POURCENTAGE,
      },
    };
  },
  computed: {
    echeanciers() {
      return this.contrat.echeancier
        .filter(el => el.debutPeriode > this.payload.dateIndexation);
    },
  },
  methods: {
    async indexeContrat() {
      this.isError = false;
      this.messagesChampsVide = [];
      this.champsVide = [];
      this.messagesError = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await indexation({
          contratId: this.contrat.id,
          dateIndexation: formatDateIso(this.payload.dateIndexation),
          valeurIndexationActuel: this.payload.valeurIndexationActuel,
          dateIndexationActuel: formatDateIso(this.payload.dateIndexationActuel),
        });
        messageSucces(this.$t('detailContrat.indexation.successIndexationMsg'));
        this.$emit('reload');
        this.$parent.close();
      } catch (e) {
        this.isError = true;
        if (e.response && e.response.data && e.response.data.error) {
          validation(e.response, this.messagesError, this.contrat.contratsMateriels);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesError, this.messagesChampsVide, translate);
          this.affichageMessagesErreur = true;
          throw e;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async getIndiceEtValeur() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const { items } = (await getAll({ limit: NO_PAGINATION })).data.result;
        this.indiceEtValeurs = items;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    this.payload.valeurIndexationActuel = this.contrat.valeurIndexationActuel;
    this.payload.dateIndexationActuel = this.contrat.dateIndexationActuel;
    if (this.contrat.typeIndexation === TYPE_INDEXATION_INDICE) {
      await this.getIndiceEtValeur();
      if (this.payload.indiceSelected === null) {
        const findIndice = this.indiceEtValeurs
          .find(el => el.id === this.contrat.indiceReferenceId);
        if (findIndice) this.payload.indiceSelected = findIndice;
      }
    }
  },
};
</script>
